import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

// Import the Google Maps API key from the map.config.ts file
import mapConfig from '@/pages/mapView/components/map/map.config';
const TOKEN_GOOGLE = mapConfig.TOKEN_GOOGLE;

// Initialize Google Maps only once
let isGoogleMapsInitialized = false;
let initializedLanguage = null;

export const initGoogleMaps = (lang = 'en') => {
  const language = lang === 'he' ? 'iw' : (lang || 'en');

  if (isGoogleMapsInitialized) {
    // If language changes, the app currently does a full reload (see App.vue lang watcher).
    // Avoid re-installing the plugin multiple times.
    if (initializedLanguage === language) return;
    return;
  }

  Vue.use(VueGoogleMaps, {
    load: {
      key: TOKEN_GOOGLE,
      language,
      libraries: 'places,visualization,geometry',
      // Pass `loading=async` as an extra query string parameter so the script
      // tag the plugin injects ends up as
      //   https://maps.googleapis.com/maps/api/js?...&loading=async
      // which silences the "Google Maps JavaScript API has been loaded directly
      // without loading=async" performance warning. vue2-google-maps iterates
      // every key on `load` into the URL, so unknown keys like this one are
      // simply appended.
      loading: 'async'
    },
    installComponents: true // This ensures all components are installed
  });

  isGoogleMapsInitialized = true;
  initializedLanguage = language;
};

// Export the Google Maps components for direct use
export const { gmapApi } = VueGoogleMaps;
